import React from 'react';

import PropTypes from 'prop-types';
import { parse as parseQueryString } from 'query-string';
import { connect } from 'react-redux';

import Helmet from 'wanderu-component-helmet';
import { Redirect } from 'wanderu-component-react-router-link';
import {
    PageDialogWrapper,
} from 'wanderu-components';
import {
    userInfoSelectors,
} from 'wanderu-ducks-account';
import {
    localize,
} from 'wanderu-i18n';

import config from '../../config/baseApp.locales';
import BareLogInContainer from './BareLogIn';

import styles from './LogIn.scss';

function LogInContainer(props) {
    const {
        location,
        isLoggedIn,
        t,
    } = props;

    const {
        email,
        redirectTo,
    } = parseQueryString(location.search);

    if (isLoggedIn) {
        return (
            <Redirect
                href={redirectTo || '/account/mytrips'}
                queries={{
                    redirectTo: undefined,
                }}
                push
            />
        );
    }

    const title = t('log-in-to-your-account-title_meta');
    const description = t('log-in-to-your-account-description_meta');

    return (
        <div className={styles.page}>
            <Helmet
                description={description}
                supportedLocales={config.supportedLocales}
                title={title}
            />
            <PageDialogWrapper title={t('log-in')}>
                <BareLogInContainer defaultValues={{ email }} />
            </PageDialogWrapper>
        </div>
    );
}

LogInContainer.propTypes = {
    location: PropTypes.object,
    isLoggedIn: PropTypes.bool,
};

LogInContainer.defaultProps = {
    isLoggedIn: false,
};

const mapStateToProps = (appState) => {
    return {
        isLoggedIn: userInfoSelectors.selectUserLoggedIn(appState),
    };
};

export {
    LogInContainer,
    mapStateToProps,
};

const localizedLogInContainer = localize(LogInContainer, ['t'], config.namespace);
export default connect(mapStateToProps)(localizedLogInContainer);
